(() => {
  const init = () => {
    const root = document.querySelector('[data-allurez-home]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cleanComparePrices = () => root.querySelectorAll('product-card .line-through').forEach(price => {
      const digits = price.textContent.replace(/\D/g, '');
      price.hidden = !digits || Number(digits) === 0;
    });
    new MutationObserver(cleanComparePrices).observe(root, {childList:true, subtree:true});
    cleanComparePrices();
    const tabs = [...root.querySelectorAll('[data-shelf]')];
    const allLink = root.querySelector('#shelf-all');
    const select = tab => {
      tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        root.querySelector('#shelf-panel-' + item.dataset.shelf).hidden = !selected;
      });
      allLink.href = tab.dataset.collectionUrl;
      allLink.textContent = tab.dataset.viewAll;
    };
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(next);next.focus();
      });
    });
    const dialog = root.querySelector('#financing-dialog');
    document.querySelectorAll('.allurez-home [data-open="financing-dialog"]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    const rail = root.querySelector('#category-grid');
    const previous = root.querySelector('.category-prev');
    const next = root.querySelector('.category-next');
    const update = () => {
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    const move = direction => rail.scrollBy({left: direction * (rail.querySelector('.category-card').getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0)), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(rail);
    update();
    const compact = matchMedia('(max-width:650px)');
    const arrange = () => document.querySelectorAll('#allurez-home-footer .footer-group').forEach(group => {group.open = !compact.matches;});
    compact.addEventListener('change', arrange);arrange();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
